/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:b9630281-b83c-4275-9a38-71747ba24985",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_XecSOYGli",
    "aws_user_pools_web_client_id": "27f4t3ufot7v9utmsm4r8qara4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://g7tvfpcmqfbvrnua4nfoqnbpve.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "quickfillerapi",
            "endpoint": "https://7a0riyl77d.execute-api.us-west-2.amazonaws.com/portfolio",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
